<div class="form-group">
  @if (props.label && to['hideLabel'] !== true) {
    <div class="pseudo-label" [class.has-error]="showError && props.required">
      {{ props.label }}
      @if (props.required && to['hideRequiredMarker'] !== true) {
        <span>*</span>
      }
    </div>
  }
  <ng-template #fieldComponent></ng-template>
  @if (showError) {
    <div class="invalid-feedback" [style.display]="'block'">
      <formly-validation-message [style.display]="'none'" #validationRef  [field]="field"></formly-validation-message>
      @if (validationRef) {
        {{ validationRef.errorMessage }}
      }
    </div>
  }
  @if (props.description) {
    <small class="form-text text-muted">{{ props.description }}</small>
  }
</div>
